// src/pages/ContactUs/ContactUs.js
import React, { useState } from 'react';
import './ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Show success message
    setShowSuccess(true);
    
    // Clear form
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });

    // Hide success message after 5 seconds
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  return (
    <div className="contact-page page-content">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">Contact Us</h1>
          <p className="page-subtitle">We'd Love to Hear from You</p>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info-section">
        <div className="container">
          <div className="contact-info-grid">
            <div className="contact-card">
              <div className="contact-icon">📍</div>
              <h3>Visit Us</h3>
              <p>DisneyLand Preschool</p>
              <p>I-386 Govindpuram</p>
              <p>Ghaziabad, 201013</p>
            </div>
            <div className="contact-card">
              <div className="contact-icon">📞</div>
              <h3>Call Us</h3>
              <p>+91 93502 07576</p>
              <p>+91 70115 93582</p>
              <p>Mon - Sat: 8:00 AM - 6:00 PM</p>
            </div>
            <div className="contact-card">
              <div className="contact-icon">✉️</div>
              <h3>Email Us</h3>
              <p>disneylandpreschool@gmail.com</p>
              {/* <p>admissions@disneylandpreschool.com</p>
              <p>support@disneylandpreschool.com</p> */}
            </div>
            {/* <div className="contact-card">
              <div className="contact-icon">🌐</div>
              <h3>Follow Us</h3>
              <div className="social-icons">
                <a href="#facebook" className="social-icon">f</a>
                <a href="#instagram" className="social-icon">📷</a>
                <a href="#youtube" className="social-icon">▶</a>
                <a href="#twitter" className="social-icon">🐦</a>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Contact Form and Map Section */}
      <section className="contact-form-section">
        <div className="container">
          <div className="contact-content">
            <div className="contact-form-wrapper">
              <h2>Send Us a Message</h2>
              <p className="form-description">
                Have questions? Fill out the form below and our team will get back to you within 24 hours.
              </p>

              {showSuccess && (
                <div className="success-message">
                  ✓ Details submitted successfully! We will contact you soon.
                </div>
              )}

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Your Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your name"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Enter email address"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="Enter phone number"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="What is this regarding?"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Your Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Write your message here..."
                  ></textarea>
                </div>

                <button type="submit" className="submit-btn">
                  Send Message
                </button>
              </form>
            </div>

            <div className="map-wrapper">
              <h2>Locate Us</h2>
              <div className="map-placeholder">
                <div className="map-icon">🗺️</div>
                <p>DisneyLand Preschool</p>
                <p className="map-address">I-386 Govindpuram, Ghaziabad 201013</p>
                <button className="directions-btn">Get Directions</button>
              </div>

              <div className="office-hours">
                <h3>Office Hours</h3>
                <div className="hours-list">
                  <div className="hours-item">
                    <span className="day">Monday - Friday</span>
                    <span className="time">8:00 AM - 6:00 PM</span>
                  </div>
                  <div className="hours-item">
                    <span className="day">Saturday</span>
                    <span className="time">9:00 AM - 4:00 PM</span>
                  </div>
                  <div className="hours-item">
                    <span className="day">Sunday</span>
                    <span className="time">Closed</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Frequently Asked Questions</h2>
            <div className="title-underline"></div>
          </div>
          <div className="faq-grid">
            <div className="faq-item">
              <div className="faq-icon">❓</div>
              <h3>What are the school timings?</h3>
              <p>Our school operates from 8:00 AM to 6:00 PM, Monday through Saturday. Program timings vary by age group.</p>
            </div>
            <div className="faq-item">
              <div className="faq-icon">❓</div>
              <h3>How can I schedule a campus visit?</h3>
              <p>You can call us at +91 98765 43210 or fill out the contact form above to schedule a visit.</p>
            </div>
            <div className="faq-item">
              <div className="faq-icon">❓</div>
              <h3>What is the admission process?</h3>
              <p>Visit our Admissions page for detailed information about the admission process and requirements.</p>
            </div>
            <div className="faq-item">
              <div className="faq-icon">❓</div>
              <h3>Do you provide transportation?</h3>
              <p>Yes, we provide safe and secure transportation services. Please contact us for route details.</p>
            </div>
            <div className="faq-item">
              <div className="faq-icon">❓</div>
              <h3>What safety measures do you have?</h3>
              <p>We have CCTV monitoring, trained security staff, and follow strict safety protocols for all children.</p>
            </div>
            <div className="faq-item">
              <div className="faq-icon">❓</div>
              <h3>Can parents visit during school hours?</h3>
              <p>Parents can visit by prior appointment. We encourage parent involvement in their child's education.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;